import styled from "styled-components/native";
import { color, radii, space, typography } from "@sloth-system/styled-utils";

export { TextInputContainer };

let TextInputContainer = styled.TextInput`
  background-color: ${color("common.white")};
  padding: ${space("l")};
  border-radius: ${radii("s")};
  border-color: #ccc;
  border-width: 1;
  text-align: center;
  font-family: ${typography("face.main")};
`;
